import '../../style/index.less';
import './index.less';

// style dependencies
import '../../button/style';



// WEBPACK FOOTER //
// ./components/input/style/index.tsx